var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadDrag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 31,
    viewBox: "0 0 37 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8692 21.6736L18.5062 15.3105L12.1431 21.6736",
    stroke: "#6AC5AB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5062 15.3105V29.6274",
    stroke: "#6AC5AB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8534 25.4779C33.4049 24.6321 34.6306 23.2936 35.3369 21.6738C36.0433 20.054 36.1901 18.2451 35.7542 16.5326C35.3184 14.8201 34.3246 13.3015 32.9298 12.2164C31.535 11.1314 29.8186 10.5418 28.0514 10.5407H26.0471C25.5656 8.67827 24.6681 6.94926 23.4222 5.48362C22.1763 4.01798 20.6144 2.85386 18.8538 2.07878C17.0932 1.30369 15.1799 0.937803 13.2575 1.00863C11.3352 1.07946 9.45394 1.58515 7.75518 2.48769C6.05642 3.39024 4.58437 4.66614 3.4497 6.21949C2.31503 7.77284 1.54726 9.5632 1.20411 11.456C0.860969 13.3488 0.951381 15.2947 1.46855 17.1475C1.98572 19.0003 2.91619 20.7118 4.19001 22.1532",
    stroke: "#6AC5AB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDrag);
export default __webpack_public_path__ + "static/media/upload_drag.2d75e3737504b76511e4c7dd5173b14c.svg";
export { ForwardRef as ReactComponent };